import { render } from "./StudentCalender.vue?vue&type=template&id=3ae4da58"
import script from "./StudentCalender.vue?vue&type=script&lang=js"
export * from "./StudentCalender.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__